import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  position: fixed;
  background: ${props =>
    props.transparent ? "rgba(245, 245, 245, 0.5)" : "transparent"};
  right: ${props => (props.transparent ? "0" : "auto")};
  z-index: 99999999;

  svg {
    color: rgb(24, 144, 255) !important;
  }
`;



// WEBPACK FOOTER //
// ./src/components/LoadingChat/styles.js